export default __webpack_public_path__ + "static/media/ilustracao-homem-com-celular-desktop.a571ba2f.svg";